import React from 'react';
import { Link } from 'react-router-dom';
import { HugeiconsIcon } from '@hugeicons/react';
import { GolfCartIcon, Target01Icon, AiBrain02Icon, GiftIcon, Mail01Icon } from '@hugeicons/core-free-icons';

const Footer = () => {
  return (
    <footer className="relative py-12 sm:py-14 lg:py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Grass Background */}
      <div className="absolute inset-0">
        <img
          src="https://res.cloudinary.com/dzcrxivpm/image/upload/v1758892196/openart-image_BFSvN8ek_1758804974015_raw_geltxw.webp"
          alt="Golf grass texture"
          width="1920"
          height="1080"
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>

      {/* Dark Green Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-green-900/85 via-green-800/90 to-green-900/95"></div>

      <div className="max-w-5xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <h3 className="font-playfair font-bold text-3xl text-white mb-4">Golf Like a Caddie</h3>
          <p className="text-green-100 text-lg leading-relaxed max-w-2xl mx-auto">
            I'm sharing 10+ years of caddie secrets to help you play smarter golf.
            Master the mental game that separates pros from amateurs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-start">
          {/* Left Column - About Ryan */}
          <div className="text-center md:text-left">
            <h4 className="font-inter font-bold text-xl text-white mb-4">About Ryan Tewksbury</h4>
            <div className="space-y-3 text-green-100">
              <p className="flex items-start space-x-3">
                <HugeiconsIcon icon={GolfCartIcon} size={20} />
                <span>Over 10 years as a caddie at various private golf courses</span>
              </p>
              <p className="flex items-start space-x-3">
                <HugeiconsIcon icon={Target01Icon} size={20} />
                <span>I've walked thousands of rounds with players at every level</span>
              </p>
              <p className="flex items-start space-x-3">
                <HugeiconsIcon icon={AiBrain02Icon} size={20} />
                <span>I know what separates good players from great ones</span>
              </p>
              <p className="flex items-start space-x-3">
                <HugeiconsIcon icon={GiftIcon} size={20} />
                <span>Now I'm sharing these battle-tested strategies with you</span>
              </p>
            </div>
          </div>

          {/* Right Column - Contact */}
          <div className="text-center md:text-right">
            <h4 className="font-inter font-bold text-xl text-white mb-4">Questions?</h4>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 mb-6">
              <p className="text-green-100 font-medium mb-2">
                <HugeiconsIcon icon={Mail01Icon} size={20} />
                I'm here to help you play better golf
              </p>
              <p className="text-green-200 text-sm">
                These strategies have helped hundreds of golfers drop strokes immediately.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Section - Legal */}
        <div className="mt-12 pt-8 border-t border-white/20 text-center">
          <p className="text-sm text-green-200">
            © 2025 Ryan Tewksbury. All rights reserved. |{' '}
            <Link to="/privacy" className="hover:text-yellow-400 transition-colors underline">Privacy Policy</Link> |{' '}
            <Link to="/terms" className="hover:text-yellow-400 transition-colors underline">Terms of Service</Link>
          </p>
          <p className="text-xs text-green-300 mt-2">
            Professional golf instruction and course management strategies. Results may vary.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;